import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { Store } from '@ngrx/store';
import { DropdownOption } from 'src/app/models/dropdown-option.model';
import { AddEJournalRequest, ClearSearchedFoodList, EditRecordsRequest, FetchSearchedDailyMealAndDrinkTrackerListRequest } from '../../core/my-journal.actions';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { GetColorType, GetMealType, GetSearchedDailyMealList } from '../../core/my-journal.selector';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { AddEJournalDetailsModel } from '../../model/list.model';
import { EJournalConstant } from '../../constant/e-journal.enum';

@Component({
  selector: 'app-add-daily-meal',
  templateUrl: './add-daily-meal.component.html',
  styleUrls: ['./add-daily-meal.component.css']
})
export class AddDailyMealComponent implements OnInit, OnDestroy {
  @Input() data: any;
  form: FormGroup = new FormGroup({
    mealType: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(9)]),
    color: new FormControl('', [Validators.required]),
    comments: new FormControl('')
  });
  errorMessages: any = {};
  errorMessageMap = {
    mealType: {
      required: 'This field is required.',
    },
    name: {
      required: 'This field is required.',
    },
    quantity: {
      required: 'This field is required.',
      min: 'Value must not be 0 or less.',
      max:'Value must not be more than 9.'
    },
    color: {
      required: 'This field is required.',
    },
  }
  mealType: DropdownOption[] = [];
  mealTypeLoading: boolean = false;
  colorType: DropdownOption[] = [];
  colorTypeLoading: boolean = false;
  searchedHasNext: boolean;
  loading: boolean = false;
  searchedPageNumber: number;
  dataSource: any[] = []
  foodSearchTooltip = `Search works best using single words.`
    + `\nTo see all foods of a certain type, try searching by category:`
    + `\n \u2022 Vegetable`
    + `\n \u2022 Fruit`
    + `\n \u2022 Beverage`
    + `\n \u2022 Condiment`
    + `\n \u2022 Snack`
    + `\n \u2022 Dairy`
    + `\n \u2022 Soup`
    + `\n \u2022 Dessert`
    + `\n \u2022 Meat`
    + `\n \u2022 Seafood`
  colDef = [
    'foodItem',
    'servingQuantity',
    // 'servingType',
    'color',
  ]
  memberId: any;
  mode:string='add';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private store: Store, private commonService: CommonService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.store.dispatch(ClearSearchedFoodList())
    this.store.select(GetSearchedDailyMealList).pipe(takeUntil(this.onDestroy)).subscribe(dailyMeal => {
      this.dataSource = dailyMeal.list;
      this.loading = dailyMeal.loading;
      this.searchedPageNumber = dailyMeal.pageNumber;
      this.searchedHasNext = dailyMeal.hasNext
    });
    this.store.select(GetMealType).subscribe(mealType => {
      this.mealType = mealType.list;
      this.mealTypeLoading = mealType.loading;
    })


    this.store.select(GetColorType).pipe(takeUntil(this.onDestroy)).subscribe(todType => {
      this.colorType = todType.list;
      this.colorTypeLoading = todType.loading
    })

    this.form.controls['name'].valueChanges.pipe(takeUntil(this.onDestroy), debounceTime(1000)).subscribe(value => {
      const trimmedValue = value?.trim();
      if(trimmedValue){
      this.store.dispatch(FetchSearchedDailyMealAndDrinkTrackerListRequest({
        payload: {
          pageNumber: 1,
          searchText: trimmedValue
        }
      }))
      }
      else{
        this.store.dispatch(ClearSearchedFoodList())
      }

    })

    if(this.data?.previousData){
      this.mode = 'edit'
      this.form.patchValue({
        mealType: this.data?.previousData?.type,
        name: this.data?.previousData?.food,
        quantity: this.data?.previousData?.serving,
        color: this.data?.previousData?.color,
        comments: this.data?.previousData?.comments || ''
      })
    }
    else{
      this.mode='add'
    }

  }

  addData() {
    this.errorMessages = {};
    if (this.form.invalid) {
      this.errorMessages = this.commonService.checkFormValidation(this.form, this.errorMessageMap);
      return;
    }
    if(this.mode === 'add'){
      const foodIntake: any[] = [];
      foodIntake.push({ ...this.form.value, points: this.form.value.quantity })
      const payload: AddEJournalDetailsModel['request'] = {
        date: this.data?.data?.selectedDate?.date,
        ...(this.data?.data?.memberId ? { forUserId: +this.data?.data.memberId } : {}),
        ...(this.data?.data?.groupId ? { groupId: +this.data?.data.groupId } : {}),
        foodIntake: foodIntake,
        physicalActivity: [],
        screenTime: []
      }

      if (!this.data?.data?.selectedDate?.isNormalJournalingRLExists) {
        this.store.dispatch(AddEJournalRequest({
          payload: payload
        }))
        return;
      }

      this.commonService.openConfirmationDialog({
        data: {
          message: `You have a <span class="text-[rgb(224,79,57)]">Red Light</span> total in your Behavior Tracker for this date. Do you want to delete your Behavior Tracker total and replace with the total of your e-Journal entries?`,
          submitText: 'Yes',
          classList: 'w-[40vw]',
          handleSubmit: () => {
            this.commonService.closeDialog();
            this.store.dispatch(AddEJournalRequest({
              payload: payload
            }))
          },
          cancelText: 'No',
          handleCancel: () => {
            this.commonService.closeDialog();
          }
        }
      });
    }
    else{
      const payload = {...this.form.value,points: this.form.value.quantity}
      this.store.dispatch(EditRecordsRequest({
        payload:{
          data:payload,
          ...(this.data?.data?.memberId ? { forUserId: +this.data?.data.memberId } : {}),
          date: this.data?.data?.selectedDate?.date,
          params:{
            recordId:this.data.previousData.id,
            recordType:EJournalConstant.mealRecordType
          }
        }
      }))
    }
  }

  closeModel() {
    this.commonService.closeDialog();
  }

  onScroll() {
    if (this.searchedHasNext && !this.loading) {
      this.store.dispatch(FetchSearchedDailyMealAndDrinkTrackerListRequest({
        payload: {
          pageNumber: this.searchedPageNumber + 1,
          searchText: this.form.controls['name'].value?.trim()
        }
      }))
    }
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
